import { Divider, Stack, type StackProps } from '@mui/material';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import { ExposuresListStyle } from './ExposuresList.styles';

const ExposuresList: FC<StackProps> = ({ children, ...rest }) => (
  <Stack
    {...rest}
    sx={[ExposuresListStyle, ...castArray(rest.sx)]}
    divider={<Divider orientation="horizontal" flexItem />}
  >
    {children}
  </Stack>
);

export default ExposuresList;
